import { useMutation, useQueryClient } from '@tanstack/react-query'
import { updateSmokerRateOverrideRuleStatus } from '../../../api/plan-smoker-rate-override-rules-api'
import type { PlanSmokerRateOverrideRuleStatus } from '../enums/plan-smoker-rate-override-rule.enum'
import { SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY } from '../pages/ListPlanSmokerRateOverride/hooks/useGetSmokerRateOverrideRules'
import { SMOKER_RATE_OVERRIDE_RULE_QUERY_KEY } from './useGetSmokerRateOverrideRule'

interface Variables {
  id: string
  status: PlanSmokerRateOverrideRuleStatus
}

export function useToggleSmokerRateOverrideRuleStatus() {
  const queryClient = useQueryClient()

  return useMutation<unknown, unknown, Variables>({
    mutationFn: ({ id, status }) =>
      updateSmokerRateOverrideRuleStatus(id, { status }),
    onSettled: (_data, _err, variables) => {
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULES_QUERY_KEY],
      })
      queryClient.invalidateQueries({
        queryKey: [SMOKER_RATE_OVERRIDE_RULE_QUERY_KEY, variables.id],
      })
    },
  })
}
